module.exports = __webpack_public_path__ + "static/media/v3logoBrown.ed3084ae.svg";